import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { withTranslation } from 'react-i18next';

import AppLogoLink from './AppLogo.layout';


const decorate = compose<ComponentType>(
    withTranslation('common'),
);
export default decorate(AppLogoLink);
